import View from "../common/components/PopupInline";
import components from "./components.js";
components.define("js-PopupInline", View);